import React from "react";
import "./Footer.scss"
import Image from "next/image";

export default function Footer() {

  function getCurrentYear() {
    return new Date().getFullYear();
  }

  return (
    <div className="footer">
      <div className="content">
        <div className="row-1">
          <div className="d-flex align-items-center">
            <div className="row-1-address">
              <a
                href="mailto:janessa@altraedge.com?subject=Reaching%20Out"
                target="_blank"
                rel="noopener noreferrer"
              >Contact Us ✉️</a>
            </div>
          </div>
          <div className="sr-only">
            <div>powered by</div>
            <a
              href="https://www.stephrowe.ca"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                width={110}
                height={40}
                alt={"Steph Rowe Soft Logo"}
                src="/imgs/stephrowesoftlogo-footer.png"
              />
            </a>
          </div>
        </div>
        <div className="row-2">
          <div>{`Copyright © ${getCurrentYear()} Altra Edge - All Rights Reserved.`}</div>
        </div>
      </div>
    </div>
  );
}
